// extracted by mini-css-extract-plugin
export default {"products":"Yx-z","card":"Zx-z","oosMessaging":"_x-z"};